export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const REMOVE_CONTACT = 'REMOVE_CONTACT';
export const IMPORT_CONTACTS = 'IMPORT_CONTACTS';
export const REMOVE_MANY_CONTACTS = 'REMOVE_MANY_CONTACTS';
export const SAVE_SELECTED_CONTACTS = 'SAVE_SELECTED_CONTACTS';
export const ADD_GROUPS_TO_CONTACTS = 'ADD_GROUPS_TO_CONTACTS';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const UPDATE_REPLACED_CONTACT = 'UPDATE_REPLACED_CONTACT';